import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import UserSettings from '../settings/model/Settings';

interface IMessageListHeaderItemProps {
  translationId: string;
  defaultTranslationMessage: string;
  field: string;
  colSize: number;
  settings: UserSettings;
  sortField: string;
  isDesc: boolean;
  sortHandler: (sortField: string) => void;
}

export class MessageListHeaderItem extends React.Component<IMessageListHeaderItemProps> {
  constructor(props: IMessageListHeaderItemProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  public handleClick() {
      this.props.sortHandler(this.props.field);
  }

  public render() {
    const { colSize, translationId, defaultTranslationMessage, sortField, field, isDesc } = this.props;
    return (
      <th className={"col-sm-" + colSize} scope="col">
        <span className="pointer" onClick={this.handleClick}><FormattedMessage id={translationId} defaultMessage={defaultTranslationMessage} />
            {sortField === field && <i className="material-icons">{isDesc ? 'arrow_drop_down' : 'arrow_drop_up'}</i>}
        </span>
      </th>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    isDesc: state.mail.isDesc,
    settings: state.settings.settings,
    sortField: state.mail.sortField,
  };
}

export default connect(mapStateToProps, null)(MessageListHeaderItem);




// WEBPACK FOOTER //
// ./src/components/mail/MessageListHeaderItem.tsx